import flatten from "lodash/flatten";

export const toleranceList = flatten(
  ["f", "m", "c", "v"].map((iso1) => {
    return ["H", "K", "L"].map((iso2) => `ISO 2768-${iso1}${iso2}`);
  }),
);
